module.exports = __webpack_public_path__ + "img/account-nav.081b6a5c.svg";